import * as actiontypes from "../ActionTypes";

// 🔹 SAVE PROGRAM COVER IMAGE
export const saveProgramCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actiontypes.SAVE_PROGRAM_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});

export const saveProgramCoverImageSuccess = (data) => ({
  type: actiontypes.SAVE_PROGRAM_COVERIMAGE_SUCCESS,
  payload: data,
});

export const saveProgramCoverImageFailure = (error) => ({
  type: actiontypes.SAVE_PROGRAM_COVERIMAGE_FAILURE,
  payload: error,
});

// 🔹 UPDATE PROGRAM COVER IMAGE
export const updateProgramCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actiontypes.UPDATE_PROGRAM_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});

export const updateProgramCoverImageSuccess = (data) => ({
  type: actiontypes.UPDATE_PROGRAM_COVERIMAGE_SUCCESS,
  payload: data,
});

export const updateProgramCoverImageFailure = (error) => ({
  type: actiontypes.UPDATE_PROGRAM_COVERIMAGE_FAILURE,
  payload: error,
});
// 🔹 DELETE PROGRAM COVER IMAGE
export const deleteProgramCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actiontypes.DELETE_PROGRAM_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});

export const deleteProgramCoverImageSuccess = (data) => ({
  type: actiontypes.DELETE_PROGRAM_COVERIMAGE_SUCCESS,
  payload: data,
});

export const deleteProgramCoverImageFailure = (error) => ({
  type: actiontypes.DELETE_PROGRAM_COVERIMAGE_FAILURE,
  payload: error,
});
